import { useCallback, useMemo } from "react";
import { TypeaheadInput, SearchOption } from "@jsq/ds/core";
import { useGetEntitiesWithSearchWithoutArenaLazyQuery } from "~/graphql/supergraphHooks";
import { entitySearchClass } from "./styles_vanilla.css";
import { EntitySearchOption } from "./types";

const EntitySearchBox = ({
  onEntitySelected,
}: {
  onEntitySelected: (entity: EntitySearchOption) => void;
}) => {
  const [getEntityWithSearch, { loading, error, data }] =
    useGetEntitiesWithSearchWithoutArenaLazyQuery();

  const entityOptions: EntitySearchOption[] = useMemo(
    () =>
      data?.investmentEntitiesForProgramAssignment?.rows.map((entity) => ({
        label: entity.name,
        id: entity.id,
        arena: entity.arena ?? null,
      })) || [],
    [data],
  );

  const handleDebouncedSearch = useCallback(
    async (value?: string) => {
      if (value?.length) {
        await getEntityWithSearch({
          variables: {
            nameSearch: value.trim(),
          },
          fetchPolicy: "no-cache",
        });
      }
    },
    [getEntityWithSearch],
  );

  const handleSelection = useCallback(
    (selectedOption: SearchOption) => {
      const entityOption = selectedOption as EntitySearchOption;
      onEntitySelected(entityOption);
    },
    [onEntitySelected],
  );

  return (
    <TypeaheadInput
      className={entitySearchClass}
      isFullWidth={false}
      placeholder="Search an entity to view positions"
      options={entityOptions}
      isLoading={loading}
      isError={error !== undefined}
      isClearable
      onDebouncedSearch={handleDebouncedSearch}
      onSelectOption={handleSelection}
    />
  );
};

export default EntitySearchBox;
